/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBadge = createReactComponent("badge", "IconBadge", [
  ["path", { d: "M17 17v-13l-5 3l-5 -3v13l5 3z", key: "svg-0" }]
]);

export { IconBadge as default };
//# sourceMappingURL=IconBadge.js.map
